// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__D6hY0"};
module.exports.__checksum = "f909ecd77d95"